/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust1_PInputs */

const es_landing_trust1_p = /** @type {(inputs: Landing_Trust1_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestora náutica autorizada para tramitar el cambio de uso de Lista 7ª.`)
};

const gl_landing_trust1_p = /** @type {(inputs: Landing_Trust1_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xestora náutica autorizada para tramitar o cambio de uso de Lista 7ª.`)
};

const en_landing_trust1_p = /** @type {(inputs: Landing_Trust1_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authorised nautical manager for List 7 change-of-use processing.`)
};

/**
* | output |
* | --- |
* | "Authorised nautical manager for List 7 change-of-use processing." |
*
* @param {Landing_Trust1_PInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_trust1_p = /** @type {((inputs?: Landing_Trust1_PInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust1_PInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_trust1_p(inputs)
	if (locale === "en") return en_landing_trust1_p(inputs)
	return es_landing_trust1_p(inputs)
});